/**
 * What makes a whole row (or a phone block) act as one control (#11635
 * slice 1, Round 15, R49; Round 17, R65): it takes focus, a click acts
 * unless it ends a text selection, and Enter or Space acts once per press.
 * The Sync history's rows and the Services list's rows share it.
 */
import type React from "react";

export interface RowActivationProps {
  tabIndex: number;
  onClick: () => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLElement>) => void;
}

export const rowActivationProps = (
  onActivate: () => void
): RowActivationProps => ({
  tabIndex: 0,
  onClick: () => {
    // A drag that selected text in the row (to copy it) is not a click on
    // it; nor is a click inside a tooltip whose events bubble here through
    // the portal while its text is selected.
    if (!(window.getSelection()?.isCollapsed ?? true)) return;
    onActivate();
  },
  onKeyDown: (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    // Space would scroll the page; the row takes it.
    event.preventDefault();
    // A held key acts once.
    if (event.repeat) return;
    onActivate();
  },
});
